import React, { createContext, Dispatch, useState } from "react"; 
import { LectureSummaryModel } from "../generated/api";


interface CartContextType {
  cartItems:LectureSummaryModel[]; 
  addToCart: (item: LectureSummaryModel) => void;
  removeFromCart: (lectureToken?: string) => void;
  isItemInCart: (lectureToken?: string) => boolean;
  clearCart:()=>void;
}

const CartContext = React.createContext<CartContextType>({
  cartItems:[], 
  addToCart: () => { },
  removeFromCart: () => { },
  isItemInCart: () => false,
  clearCart:()=>{}
});



export default CartContext

